module.exports = [{"type":"hash","text":"Data Compression"},{"type":"normal","text":"All response data from Websocket server are compressed into GZIP format. Clients have to decompress them for further use."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/introduce/02_data_compress.json
// module id = Q5Jp
// module chunks = 3